import React from "react";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

// As rotas que pertencem à aba Listagem. Ela cobre duas (Cálculos e Consultas),
// então o destaque não pode vir do casamento de prefixo do NavLink: sem `exact`,
// `/calculator-api` casaria também com `/calculator-api/vinculacao`; com `exact`,
// deixaria de casar com `/calculator-api/queries`. Daí a lista explícita.
export const LISTAGEM_PATHS = ["/calculator-api", "/calculator-api/queries"];

const VINCULACAO_PATH = "/calculator-api/vinculacao";

// Abas de 1º nível, por rota — cada uma é linkável e sobrevive a refresh.
export default function CalculatorApiTabs() {
  return (
    <div className="mb-5">
      <div className="d-flex align-items-center mb-5">
        <span className="svg-icon svg-icon-2x svg-icon-primary mr-3">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Calculator.svg")} />
        </span>
        <h1 className="azul-cabecalho mb-0">Consumo API B2B</h1>
      </div>

      <ul className="nav nav-tabs nav-tabs-line">
        <li className="nav-item">
          <NavLink
            className="nav-link"
            activeClassName="active"
            to={LISTAGEM_PATHS[0]}
            isActive={(match, location) =>
              LISTAGEM_PATHS.includes(location.pathname)
            }
          >
            Listagem
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            className="nav-link"
            activeClassName="active"
            to={VINCULACAO_PATH}
          >
            Vinculação
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
